import React from 'react';
import { Typography, Box, Divider, Link } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { SITE_NAME } from '../../constants/site';

interface Row {
  label: string;
  value: React.ReactNode;
}

const LegalNoticePage: React.FC = () => {
  const rows: Row[] = [
    {
      label: '事業者',
      value: 'PULSE Development',
    },
    {
      label: '運営責任者',
      value: 'Yuki Umezu',
    },
    {
      label: '所在地',
      value: '〒561-0851 大阪府豊中市服部元町2丁目7番25号',
    },
    {
      label: '電話番号',
      value: 'ご請求があった場合、遅滞なく開示いたします。お問い合わせフォームよりご請求ください。',
    },
    {
      label: 'メールアドレス',
      value: (
        <Link href="https://dev.plsdb.com/contact" target="_blank" rel="noopener noreferrer" color="text.secondary">
          お問い合わせフォーム
        </Link>
      ),
    },
    {
      label: 'サイトURL',
      value: 'https://plsdb.com/',
    },
    {
      label: '販売価格',
      value: '各プランの料金ページに表示の金額（消費税込）。詳細は料金プランページをご確認ください。',
    },
    {
      label: '商品代金以外の必要料金',
      value: 'インターネット接続料金・通信料金等はお客様のご負担となります。',
    },
    {
      label: '支払方法',
      value: 'クレジットカード決済（Stripeを通じて処理されます。当サービスはカード情報を一切保持しません）',
    },
    {
      label: '支払時期',
      value: 'お申し込み時に課金され、以降は契約期間（月額／年額）に応じて自動更新時に課金されます。',
    },
    {
      label: 'サービス提供時期',
      value: '決済完了後、ただちにご利用いただけます。',
    },
    {
      label: '返品・キャンセル',
      value: 'デジタルサービスの性質上、決済完了後の返金・返品は原則お受けしておりません。次回更新の停止はマイページよりいつでも行えます。',
    },
    {
      label: '解約方法',
      value: '設定の「サブスクリプション」より、いつでも解約手続きが可能です。解約後も、契約期間終了時まではプラン機能をご利用いただけます。',
    },
    {
      label: '動作環境',
      value: '最新版の主要ブラウザ（Chrome／Safari／Edge）でのご利用を推奨します。',
    },
  ];

  return (
    <>
      <Helmet>
        <title>特定商取引法に基づく表記 | {SITE_NAME}</title>
      </Helmet>
      <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 4, mt: 4, fontWeight: 'bold' }}>
        特定商取引法に基づく表記
      </Typography>
      <Typography sx={{ mb: 4, color: 'text.secondary' }}>
        本表記は、特定商取引に関する法律第11条（通信販売についての広告）に基づき、{SITE_NAME} の有料サービスについて表示するものです。
      </Typography>
      <Divider sx={{ mb: 4 }} />
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '200px 1fr' },
          rowGap: 2,
          columnGap: 3,
        }}
      >
        {rows.map((row, i) => (
          <React.Fragment key={i}>
            <Typography sx={{ fontWeight: 700, color: 'text.primary' }}>{row.label}</Typography>
            <Typography component="div" sx={{ color: 'text.secondary' }}>{row.value}</Typography>
          </React.Fragment>
        ))}
      </Box>
      <Divider sx={{ my: 4 }} />
      <Box sx={{ color: 'text.secondary' }}>
        <Typography variant="body2">制定日：2026年5月24日</Typography>
      </Box>
    </>
  );
};

export default LegalNoticePage;
